<template>
    <div :class="class"
        v-if="showField()">

        <div v-if="checkAutomaticOriginIdentifier">
            <div v-if="!hasAutomaticOriginIdentifier || user">
                <Field v-if="$root.features?.users?.featureFields
                    && $root.features?.users?.featureFields.some(field => field.name == field_name)"
                    v-model="formData.features[field_name]" :errorMessage="errorMessage" :label="label"
                    :disabled="disabled" :required="required" :type="type" />
                <Field v-else v-model="formData[field_name]" :errorMessage="errorMessage" :label="label"
                    :disabled="disabled" :required="required" :type="type" />
            </div>
            <div v-else>
                <Field modelValue="[...]" :label="label" :disabled="true" :type="type" />
            </div>
        </div>

        <div v-if="checkAutomaticEmail">
            <div v-if="!hasAutomaticEmail || user">
                <Field v-if="$root.features?.users?.featureFields
                    && $root.features?.users?.featureFields.some(field => field.name == field_name)"
                    v-model="formData.features[field_name]" :errorMessage="errorMessage" :label="label"
                    :disabled="disabled" :required="required" :type="type" />
                <Field v-else v-model="formData[field_name]" :errorMessage="errorMessage" :label="label"
                    :disabled="disabled" :required="required" :type="type" />
            </div>
            <div v-else>
                <Field :modelValue="`[...]@${userTypeEmailDomain}`" :label="label" :disabled="true" :type="type" />
            </div>
        </div>

        <div v-if="!checkAutomaticEmail && !checkAutomaticOriginIdentifier">
            <Field v-if="$root.features?.users?.featureFields
                && $root.features?.users?.featureFields.some(field => field.name == field_name)"
                v-model="formData.features[field_name]" :errorMessage="errorMessage" :label="label" :disabled="disabled"
                :required="required" :type="type" />
            <Field v-else v-model="formData[field_name]" :errorMessage="errorMessage" :label="label"
                :disabled="disabled" :required="required" :type="type" />
        </div>

    </div>
</template>

<script>
import Field from "@/components/common/form/Field.vue";

export default {
    components: {
        Field,
    },
    props: {
        user: {
            type: Object,
            default: null,
        },
        formData: {
            type: Object,
            required: true
        },
        field_name: {
            type: String,
            required: true
        },
        required: {
            type: Boolean,
            default: false
        },
        errorMessage: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            required: true
        },
        checkAutomaticOriginIdentifier: {
            type: Boolean,
            default: false
        },
        hasAutomaticOriginIdentifier: {
            type: Boolean,
            default: false
        },
        checkAutomaticEmail: {
            type: Boolean,
            default: false
        },
        hasAutomaticEmail: {
            type: Boolean,
            default: false
        },
        userTypeEmailDomain: {
            type: String,
            default: ''
        },
        class: {
            type: String,
            default: ''
        }
    },
    data() {
        return {};
    },
    methods: {
        showField() {
            return !this.$root.features?.users?.featureLoginHiddenFields || !this.$root.features?.users?.featureLoginHiddenFields.some(field => field == this.field_name);
        },
    }
};
</script>
